import { BrowserRouter } from "react-router-dom";

import Router from "./Router";
import { store } from "./api/store";
import { Provider } from "react-redux";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
